import { IsNotEmpty, IsOptional, IsString, IsUUID } from 'class-validator';
import { ExactlyOneDefined } from '@dermloop/utils';
import { BaseDto } from '../base.dto';

export interface TeleResponseReviewDto extends BaseDto {
  teleAssessmentId?: string;
  pathologicalAssessmentId?: string;
  note?: string;
}

export class CreateTeleResponseReviewDto {
  @IsOptional()
  @IsNotEmpty()
  @IsString()
  @IsUUID()
  @ExactlyOneDefined<CreateTeleResponseReviewDto>(['pathologicalAssessmentId'])
  teleAssessmentId?: string;

  @IsOptional()
  @IsNotEmpty()
  @IsString()
  @IsUUID()
  pathologicalAssessmentId?: string;

  @IsOptional()
  @IsString()
  note?: string;

  @IsOptional()
  @IsString()
  patientResponseNote?: string;
}

export class UpdateTeleResponseReviewDto {
  @IsOptional()
  @IsString()
  note?: string;
}

export class SearchTeleResponseReviewDto {
  @IsOptional()
  @IsUUID()
  teleAssessmentId?: string;

  @IsOptional()
  @IsUUID()
  pathologicalAssessmentId?: string;
}
